import { isEndedLifecycleState } from '../services/TrackingWorksheetBuilder';

/**
 * EN-1558: whether a pig run that was just read from the API (GET /pigrun/active/{id}) has left the live view.
 * The API answers that read for any run, including one that someone else ended ('D') or cancelled ('X'), so
 * the client drops it from the live view instead of storing it again. Only a 404 removed a run before.
 */
export function hasPigRunLeftLiveView(
  refreshed: { lifecycleState?: string | null } | null | undefined
): boolean {
  return isEndedLifecycleState(refreshed?.lifecycleState);
}
